<template>
  <el-card>
    <el-form size="default">
      <h3>Filters</h3>
      <div class="filter-container history-form">
        <el-row :gutter="10">
          <el-col :span="6" :xs="24">
            <el-form-item>
              <el-select
                v-model="filter.item_type"
                placehoeder="Type"
                class="filter-item"
                @update:modelValue="update"
              >
                <el-option
                  v-for="item in HistoryItemLabels"
                  :key="item.type"
                  :label="item.label"
                  :value="item.type"
                >
                  {{ item.label }}
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" :xs="24">
            <el-form-item>
              <el-input
                v-model="filter.item_id"
                type="number"
                @update:modelValue="update"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10" :xs="24">
            <el-form-item>
              <DateRangePicker
                v-model="range"
                :force-desktop="true"
                @update:modelValue="update"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </el-card>
</template>

<script lang="ts">
import { defineComponent, ref, computed, reactive } from 'vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import { IVersionsFilter } from '@/apps/traforama/interfaces/versions'

import { HistoryItemLabels } from '@/api/types'

export default defineComponent({
  name: 'FilterForm',
  components: {
    DateRangePicker
  },
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const defaults = {
      item_type: props.type,
      item_id: props.id,
      created_at_gteq: '',
      created_at_lteq: ''
    }

    const filter = reactive<IVersionsFilter>({
      ...defaults
    })

    const update = () => {
      context.emit('update:modelValue', { ...filter })
      context.emit('update', {})
    }

    const reset = () => {
      context.emit('update:modelValue', {})
      context.emit('update', {})
    }

    const range = computed({
      get: () => {
        return [filter.created_at_gteq, filter.created_at_lteq]
      },
      set: (val) => {
        if (Array.isArray(val) && val.length === 2) {
          filter.created_at_gteq = val[0]
          filter.created_at_lteq = val[1]
        } else {
          filter.created_at_gteq = ''
          filter.created_at_lteq = ''
        }
      }
    })
    return {
      update,
      reset,
      range,
      filter,
      HistoryItemLabels
    }
  }
})
</script>

<style lang="scss" scoped>
.history-form {
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
}
h3 {
  margin: 7px 0 5px 8px;
}
:deep(.el-card__body) {
  padding: 0px 5px;
}
</style>
